import { useTranslation } from 'react-i18next';
const RewardsBanner = () => {
    const { t } = useTranslation();
    return (
        <div className="mt-4 mb-6 c-notification c-notification_rewards-light">
            <figure className="d-none d-xs-block align-self-start mb-xs-0">
                <img src="https://pro-static.h10hotels.com/templates/H10/src/images/logo-rewards-black.svg" />
            </figure>
            <div className="flex-wrap gap-2 info w-100 d-flex justify-content-between align-items-center">
                <div className="gap-3 d-flex">
                    <figure className="d-xs-none align-self-start">
                        <img src="https://pro-static.h10hotels.com/templates/H10/src/images/logo-rewards-black.svg" />
                    </figure>
                    <div>
                        <p className="mb-1 text-sm fw-semibold text-uppercase">
                            <span className="text-rewards">5% de descuento</span> en todas tus reservas por ser DE H10 REWARDS
                        </p>
                        <a id="openLogin" className="text-xs">Ya soy miembro</a>
                    </div>
                </div>
                <a className="btn btn-rewards" href="es/h10-rewards/hazte-socio">REGÍSTRATE GRATIS</a>
            </div>
        </div>
    );
}

export default RewardsBanner;
